exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html,\nbody,\nmaterial-app,\nmat-sidenav-container,\n.sidenav-content {\n  margin: 0;\n  width: 100%;\n  height: 100%;\n}\nh1 {\n  font-size: 26px;\n}\nh2 {\n  font-size: 20px !important;\n  font-weight: 100;\n}\nh3 {\n  font-size: 20px !important;\n  font-weight: 400 !important;\n}\n.md-dialog-container {\n  max-width: none !important;\n}\n.map-button {\n  width: 35px;\n  height: 35px;\n  text-align: center;\n}\n.app-icon-button {\n  height: 24px !important;\n}\n.author {\n  font-size: 10px;\n  padding-left: 20px;\n}\n.author a img,\n.author a span {\n  display: block;\n  float: left;\n}\n.author img {\n  margin-right: 3px;\n  width: 20px;\n  height: 20px;\n}\n@media (max-width: 600px) {\n  .author {\n    display: none;\n  }\n  h1 {\n    max-width: 400px;\n    font-size: 14px !important;\n    font-weight: 600;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/muth/Documents/privat/angular/guidr/src/assets/css/main.less
// module id = ../../../../../src/assets/css/main.less
// module chunks = main